import { Routes } from '@angular/router';

import { LayoutPrincipalComponent } from '@shared/components/layout-principal/layout-principal.component';
import { ComissoesComponent } from './comissoes/comissoes.component';

export const COMISSOES_ROUTES: Routes = [
  {
    path: '',
    component: LayoutPrincipalComponent,
    children: [
      {
        path: '',
        component: ComissoesComponent,
      },
      {
        path: 'apuracao',
        loadChildren: () =>
          import('../apuracao-comissionado/apuracao-comissionado.router').then(
            (m) => m.COMISSOES_APURACAO_COMISSIONADO_ROUTES,
          ),
      },
      {
        path: 'analise-calculo',
        loadChildren: () =>
          import('../analise-calculo/analise-calculo.router').then((m) => m.ANALISE_CALCULO_ROUTES),
      },
      {
        path: 'autorizacao-pagamento',
        loadChildren: () =>
          import('../autorizacao-pagamento/autorizacao.router').then((m) => m.COMISSOES_AUTORIZACAO_ROUTES),
      },
      {
        path: 'comissionados',
        loadChildren: () =>
          import('../comissionados/comissionados.router').then((m) => m.COMISSOES_COMISSIONADOS_ROUTES),
      },
      {
        path: 'demonstrativo-venda',
        loadChildren: () =>
          import('../demonstrativo-venda/demonstrativo-venda.router').then((m) => m.DEMONSTRATIVO_VENDA_ROUTES),
      },
      {
        path: 'demonstrativo-comissionado',
        loadChildren: () =>
          import('../demonstrativo-comissionado/demonstrativo-comissionado.router').then(
            (m) => m.DEMONSTRATIVO_COMISSIONADO_ROUTES,
          ),
      },
      {
        path: 'historico',
        loadChildren: () => import('../historico/historico.router').then((m) => m.COMISSOES_HISTORICO_ROUTES),
      },
      {
        path: 'plano-comissao',
        loadChildren: () =>
          import('../plano-comissao/plano-comissao.router').then((m) => m.COMISSOES_PLANO_COMISSAO_ROUTES),
      },
      // {
      //   path: 'tabela-condicao',
      //   loadChildren: () =>
      //     import('../tabela-condicao/tabela-condicao.router').then(
      //       (m) => m.COMISSOES_TABELAS_DE_CONDICOES_ROUTES
      //     ),
      // },
      {
        path: 'tipo-autorizacao',
        loadChildren: () =>
          import('../tipo-autorizacao/tipo-autorizacao.router').then((m) => m.COMISSOES_TIPO_AUTORIZACAO_ROUTES),
      },
    ],
  },
];
